const pathListeners = new Set<() => void>();

function emitPath(): void {
  for (const listener of pathListeners) {
    listener();
  }
}

export function readPortalPath(): string {
  return window.location.pathname;
}

export function subscribePortalPath(listener: () => void): () => void {
  pathListeners.add(listener);
  return () => {
    pathListeners.delete(listener);
  };
}

export function navigate(path: string, mode: 'push' | 'replace' = 'push'): void {
  if (mode === 'replace') {
    window.history.replaceState({}, '', path);
  } else {
    window.history.pushState({}, '', path);
  }
  emitPath();
}

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    emitPath();
  });
}

export function isAdminLoginPath(path: string): boolean {
  return path === '/admin/login';
}

export function isAdminPath(path: string): boolean {
  return path === '/admin' || path.startsWith('/admin/');
}

export function isPrefillPath(path: string): boolean {
  return path === '/prefill' || path.startsWith('/prefill/');
}

export function isContinuePath(path: string): boolean {
  return path === '/continue' || path.startsWith('/continue/');
}

export function isRevalidationPath(path: string): boolean {
  return path === '/revalidation' || path.startsWith('/revalidation/');
}

export function isContractorPath(path: string): boolean {
  return isPrefillPath(path) || isRevalidationPath(path) || isContinuePath(path);
}

export function isNativeCabinetPath(path: string): boolean {
  return path === '/account' || path === '/booking' || path === '/my';
}
